/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { converter } from '../../helpers/converter';
import { GetRegion } from '../../constants';
import { creditCardPayway, payWaySelector } from './MyAccountSelector';
import _ from 'lodash';

export class HeaderSection extends React.Component {
  constructor() {
    super();
    this.state = {
      classDrop: 'dropdown active',
      statusDrop: false,
    };
  }

  showDrop() {
    if (!this.state.statusDrop) {
      this.setState({ classDrop: 'dropdown active open', statusDrop: true });
      return;
    }
    this.setState({ classDrop: 'dropdown active', statusDrop: false });
  }

  render() {
    const showPaymentOption = this.props.hasCreditCardPayway;
    const { queryParams, payway } = this.props;
    const addedParams =
      (queryParams &&
        queryParams.device_model &&
        `&device_model=${queryParams.device_model}`) ||
      '';
    const GATEWAYS = _.get(payway, ['gateways']);
    const shouldRenderItemPayment =
      GATEWAYS &&
      /(plazavipgate|itunesgate|claropagosgate)/.test(GATEWAYS.join(''));

    return (
      <section
        id="ficha"
        className="section-0 section-ficha container mi-cuenta ficha"
      >
        <div className="col-lg-12 padding-1">
          <h3>
            {`${converter.convertApaUnicode(
              this.props.translations,
              'profile_suscription_welcome',
              '	Bienvenido/a',
            )} ${this.props.user.firstname}`}{' '}
          </h3>
        </div>
        <ul className="nav nav-pills hidden-lg hidden-md">
          <li className={this.state.classDrop}>
            <a
              className="dropdown-toggle"
              data-toggle="dropdown"
              // eslint-disable-next-line no-script-url
              href="javascript:void(0);"
              onClick={this.showDrop.bind(this)}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_nav_suscription',
                'Suscripción',
              )}
              <span className="caret" />
            </a>
            <ul
              className="dropdown-menu"
              role="menu"
              onClick={this.showDrop.bind(this)}
            >
              <li className="">
                <a href="#micuentavtc">
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_nav_suscription',
                    'Suscripción',
                  )}
                </a>
              </li>
              {GetRegion() === 'mexico' && shouldRenderItemPayment && (
                <li className="">
                  <a href="#micuentamodificarmediodepago">
                    {converter.convertApaUnicode(
                      this.props.translations,
                      'profile_nav_pay_mode',
                      'Medio de Pago',
                    )}{' '}
                  </a>
                </li>
              )}
              <li className="">
                <a href="#micuentamodifyuser">
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_nav_profile',
                    ' Mi Perfil',
                  )}
                </a>
              </li>
              <li className="">
                <a href="#micuentadevices">
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_nav_my_devices',
                    'Mis Dispositivos',
                  )}
                </a>
              </li>
              <li className="">
                <a href="#micuentacontrolpin">
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_nav_pin_code',
                    'PIN de Protección',
                  )}{' '}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul className="nav nav-pills hidden-xs hidden-sm">
          <li className="">
            <a href="#micuentavtc">
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_nav_suscription',
                'Suscripción',
              )}
            </a>
          </li>
          {GetRegion() === 'mexico' && showPaymentOption && (
            <li className="">
              <a href="#micuentamodificarmediodepago">
                {converter.convertApaUnicode(
                  this.props.translations,
                  'profile_nav_pay_mode',
                  'Medio de Pago',
                )}{' '}
              </a>
            </li>
          )}
          <li className="">
            <a href="#micuentamodifyuser">
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_nav_profile',
                ' Mi Perfil',
              )}
            </a>
          </li>
          <li className="">
            <a href="#micuentadevices">
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_nav_my_devices',
                'Mis Dispositivos',
              )}
            </a>
          </li>
          <li className="">
            <a href="#micuentacontrolpin">
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_nav_pin_code',
                'PIN de Protección',
              )}
            </a>
          </li>
        </ul>
      </section>
    );
  }
}

HeaderSection.propTypes = {
  hasCreditCardPayway: PropTypes.func,
  translations: PropTypes.shape({}),
  queryParams: PropTypes.shape({}),
  user: PropTypes.shape({
    firstname: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  translations: state.translations,
  metadata: state.metadata,
  user: state.user,
  hasCreditCardPayway: creditCardPayway(state),
  payway: payWaySelector(state),
});

export default connect(mapStateToProps)(HeaderSection);
